export default {
    title: 'Bola nájdená nová verzia aplikácie',
    button: {
        notNow: 'Spýtať sa neskôr',
        ignore: 'Ignorovať',
        refresh: 'Aktualizovať aplikáciu'
    }
};
